export const environment = {
  name: 'testing',
  serverPublicKey: 'j9T7wydRYzkK9nkAbsg1OmjHotvo5FWjQWE1h9SSxlQ=',
  production: true,
  apiBaseURL: 'https://adminapi-testing.ibexfusion.com',
  changeApi: false,
  imageAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-test/assets/images/',
  videoAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-test/assets/videos/',
  audioAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-test/assets/audios/',
  fileAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-test/assets/files/',
  mediaAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-test/assets/media/',
  logFileRequestUrl: 'https://my.ibexfusion.com/status/getSignedImportLogFileURL/',
  workerBaseUrl: 'http://localhost:3000/',
  pipeUrl: 'https://my.ibexfusion.com/pipe/',
  live: {
    apiBaseURL: 'https://adminapi-staging.ibexfusion.com',
    serverPublicKey: 'j9T7wydRYzkK9nkAbsg1OmjHotvo5FWjQWE1h9SSxlQ=',
    imageAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-staging/assets/images/',
    videoAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-staging/assets/videos/',
    audioAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-staging/assets/audios/',
    fileAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-staging/assets/files/',
    mediaAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-staging/assets/media/',
  },
  staging: {
    apiBaseURL: 'https://adminapi-testing.ibexfusion.com',
    serverPublicKey: 'j9T7wydRYzkK9nkAbsg1OmjHotvo5FWjQWE1h9SSxlQ=',
    imageAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-test/assets/images/',
    videoAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-test/assets/videos/',
    audioAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-test/assets/audios/',
    fileAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-test/assets/files/',
    mediaAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-test/assets/media/',
  }
};
